import React, { useEffect } from 'react';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

const useBodyScrollLock = ref => {
  useEffect(() => {
    clearAllBodyScrollLocks();

    return () => {
      disableBodyScroll(ref.current);
    };
  });
};

export default useBodyScrollLock;
